<!-- Copyright (c) 2024 MOCA Systems, Inc.  All rights reserved. -->

<form
	[formGroup]="internalTPFilter"
	class="filter-container"
	(focusin)="onFocusIn()"
	(focusout)="onFocusOut($event)"
>
	<ng-container [ngSwitch]="fieldType$ | async">
		<input
			#inputField
			*ngSwitchCase="'text'"
			matInput
			automationId="tpFilterTextField"
			formControlName="value"
		/>
		<ng-container *ngSwitchCase="'number'">
			<input
				#inputField
				matInput
				class="tp-filter-number-input"
				automationId="tpFilterNumberField"
				formControlName="value"
				type="number"
			/>
			<span
				[ngClass]="
					internalTPFilter.get('value').disabled
						? ['tp-filter-number-suffix', 'disabled-suffix']
						: 'tp-filter-number-suffix'
				"
			>
				{{ numericTypeOptions?.unit }}
			</span>
		</ng-container>
		<!-- BEGIN PLACEHOLDER REPLACE AS PART OF TP-6226 -->
		<!-- <mat-extended-select
			#inputField
			*ngSwitchCase="'dropdown'"
			class="full-width"
			ngDefaultControl
			name="tpFilterDropdown"
			formControlName="value"
			[placeholder]="placeholder"
			[includeFilter]="true"
			[required]="true"
			[multiSelect]="dropdownTypeOptions?.multiSelect"
			[option$]="dropdownTypeOptions?.option$"
			[includeNotSetOption]="true"
			[isNotSetValid]="true"
			[valuePath]="['value']"
		>
		</mat-extended-select> -->
		<!-- END PLACEHOLDER REPLACE AS PART OF TP-6226 -->
		<div *ngSwitchDefault></div>
	</ng-container>

	<mat-chip-listbox
		formControlName="operator"
		[compareWith]="chipComparator"
		(blur)="onTouched()"
		class="chip-container"
	>
		<mat-chip-option
			#chipApi
			automationId="tpFilterOperator"
			*ngFor="let operator of chipOperator$ | async"
			[value]="operator"
			[selectable]="internalTPFilter.get('operator').value?.key !== operator.key"
		>
			{{ operator.label }}
		</mat-chip-option>
	</mat-chip-listbox>
</form>
